module.exports = __webpack_public_path__ + "static/media/MTSLA-UST.e43e47a7.svg";